/* globals document */
import * as React from 'react';
import { autorun } from 'mobx';
import { inject } from 'mobx-react';
import * as cookies from 'browser-cookies';

import { ContextStore, ExperimentStore } from 'bernie-core';
import { AdvertisingStore } from 'src/common/stores/advertising-store';

interface MesoInitProps {
  advertising?: AdvertisingStore;
  context?: ContextStore;
  experiment?: ExperimentStore;
  locale?: string;
  siteId?: string;
}

@inject('context', 'advertising', 'experiment')
export class MesoInit extends React.Component<MesoInitProps> {
  private halt: () => any;

  public componentDidMount() {
    // If window.meso.intialize is an event queue, the loader script was already added.
    if (!(window.meso && window.meso.initialize && window.meso.initialize.isEventQueue)) {
      // Dynamically add the loader script.
      if (document) {
        const script = document.createElement('script');
        // Retrieve endpoint from advertising store.
        script.src = (this.props.advertising && this.props.advertising.adsloader) || '';
        script.type = 'module';
        document.body.appendChild(script);

        // ES5 script version to support older Microsoft browsers.
        const scriptES5 = document.createElement('script');
        // Retrieve endpoint from advertising store.
        scriptES5.src = (this.props.advertising && this.props.advertising.adsloaderes5) || '';
        scriptES5.defer = true;
        scriptES5.noModule = true;
        document.body.appendChild(scriptES5);
      }
    }

    // Initialize the page and get ads from delivery service.
    if (window) {
      this.halt = autorun(() => {
        // Retrieve data from context.
        const pageName = this.props.advertising.triggeredPageName;
        const context = this.props.context;
        const siteId = (context && context.site && context.site.id) || '';
        const locale = (context && context.locale) || '';
        const canTrack = this.getPrivacyTrackingConsent();
        // Override with props data or use context.
        const target = {
          type: 'target',
          pageId: pageName,
          siteId: this.props.siteId || siteId,
          locale: this.props.locale || locale,
          variant: 'pwa',
          canTrack
        };

        window.meso = window.meso || {};
        window.meso.initialize = window.meso.initialize || [];
        window.meso.initialize.push(target);

        // Push experiment data to the experiments framework.
        window.meso.experiments = window.meso.experiments || [];
        window.meso.experiments.push({
          type: 'update',
          experiments: this.parseExperiments()
        });
      });
    }
  }

  private parseExperiments() {
    const result = {};
    const exposures = (this.props.experiment && this.props.experiment.exposures) || {};
    // Map experiment name to bucket id in result.
    Object.keys(exposures).forEach(key => {
      if (exposures[key].hasOwnProperty('bucket')) {
        result[key] = exposures[key].bucket;
      }
    });

    return result;
  }

  private getPrivacyTrackingConsent() {
    // Retrieve data from context.
    const context = this.props.context;
    const opInPrivacy = context && context.site && context.site.optInPrivacyInfo;
    const canTrack = opInPrivacy && opInPrivacy.canTrack;
    if (canTrack) {
      return true;
    }

    // Check OIP cookie value as it will not reflect through context until extra page load
    const OIP_COOKIE = 'OIP';
    const OIP_OPT_IN = 'gdpr|1';
    const oipCookieValue = cookies.get(OIP_COOKIE);
    if (oipCookieValue && oipCookieValue.startsWith(OIP_OPT_IN)) {
      return true;
    }

    return false;
  }

  public componentWillUnmount() {
    if (typeof this.halt === 'function') {
      this.halt();
    }
  }

  public render() {
    return null;
  }
}
